export default __webpack_public_path__ + "static/media/kitchen5-beforeE-768w.5376a898.avif";